import { useModal } from '@/hooks';
import { Trans, useTranslation } from 'react-i18next';

export function AirdropLogin() {
  const { t } = useTranslation();
  const { showModal } = useModal();

  return (
    <div
      className='relative dark:text-white h-max px-2 md:px-0 pt-16 pb-6 lg:py-28 flex flex-col items-center overflow-x-hidden font-clash-display'
      // remove img with using backgroundImage
      style={{
        backgroundImage: 'url("airdrop-background.png")',
      }}
    >
      <img
        className='absolute lg:-right-24 lg:left-auto lg:top-12 lg:rotate-[30deg] lg:w-[40vw] max-w-lg -left-7 -top-7 w-20'
        src='/midle-parachute.png'
      />

      <img
        className='absolute lg:-left-24 lg:right-auto lg:bottom-6 lg:top-auto lg:w-[40vw] max-w-lg w-20 -right-4 top-16 rotate-[30deg] lg:rotate-0'
        src='/midle-parachute.png'
      />

      <img className='w-64 lg:w-[500px]' src='/airdrop-logo.svg' />

      <div className='w-full max-w-2xl'>
        <div className='h-0.5 mt-6 bg-white w-full' />
        <div className='h-0.5 mt-[1px] bg-white/20 w-full' />
      </div>

      <div className='mt-3 flex flex-col items-center space-y-2 text-[32px] font-light'>
        <div>{t('Farm')}</div>
        <img src='/midle-dollar.png' />
        <div className='px-3 text-center'>{t('by completing tasks!')}</div>
      </div>

      <div className='w-full max-w-sm mt-6'>
        <div className='h-0.5 bg-[#FFDA68] w-full' />
        <div className='h-0.5 mt-[1px] bg-[#FFDA68]/20 w-full' />
      </div>

      <div className='flex flex-col items-center text-2xl space-y-4 my-12'>
        <div>{t('Complete Tasks')}</div>

        <div className='w-3 h-3 rounded-full border-2 border-[#FFDA68]' />

        <div className='flex'>
          <Trans
            i18nKey='Collect <s>MXP</s>'
            values={{}}
            components={{
              s: <span className='text-[#FFDA68] font-bold' />,
            }}
          />
        </div>

        <div className='w-3 h-3 rounded-full border-2 border-[#FFDA68]' />

        <div>{t('Get Rewards with $MIDLE Airdrop!')}</div>
      </div>

      <div className='w-full max-w-sm'>
        <div className='h-0.5 bg-[#FFDA68] w-full' />
        <div className='h-0.5 mt-[1px] bg-[#FFDA68]/20 w-full' />
      </div>

      <button
        className='mt-20 w-72 h-16 p-0.5 text-[28px] hover:brightness-75 transition-all'
        onClick={() => showModal('login')}
        style={{
          background:
            'linear-gradient(135deg, transparent 12px, #FFDA68 calc(10% - 24px), #FFDA68 95%, transparent 12px)',
        }}
      >
        <div
          className='w-full h-full p-0.5'
          style={{
            background:
              'linear-gradient(135deg, transparent 12px, #151515 calc(10% - 24px), #151515 95%, transparent 12px)',
          }}
        >
          <div
            className='w-full h-full text-[#151515] flex items-center justify-center font-black'
            style={{
              background:
                'linear-gradient(135deg, transparent 12px, #FFDA68 calc(10% - 24px), #FFDA68 95%, transparent 12px)',
            }}
          >
            {t('Log In')}
          </div>
        </div>
      </button>

      {/* <a className='underline mt-16'>{t('View our FAQ')}</a> */}
    </div>
  );
}
